var styles = {"notification":"styles_notification__2fld3","activeLink":"styles_activeLink__3-7GM","link":"styles_link__3B4CK","picture3x2":"styles_picture3x2__1ExQb","spinAround":"styles_spinAround__1uuwy"};

export { styles as default };
//# sourceMappingURL=styles.scss.js.map
